class Tokenizer {
    type;

    constructor(type) {
        this.type = type;
    }

    getToken() {
        throw "Subclass responsibility";
    }

    parse() {
        throw "Subclass responsibility";
    }

    interpolateValue(value) {
        return value;
    }
}

module.exports = Tokenizer;